import { render, staticRenderFns } from "./testtest.vue?vue&type=template&id=0ea82215&"
import script from "./testtest.vue?vue&type=script&lang=js&"
export * from "./testtest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports